module.exports = __webpack_public_path__ + "img/mastercard.6f6cdc29.png";